import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import ErrorCard from '../ErrorCard/ErrorCard';
import QuestionsResponse from '../../../types/Analytics/QuestionsResponse';
import generateChartOptions from './chartOptions';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

interface TopQuestionsBarChartProps {
  questionsData?: QuestionsResponse[];
  isSmallScreen: boolean;
}

function TopQuestionsBarChart({
  questionsData = [],
  isSmallScreen
}: TopQuestionsBarChartProps): React.ReactElement | null {
  const [errorMessage, setErrorMessage] = useState<string>('');

  if (errorMessage) {
    return <ErrorCard errorMessage={errorMessage} />;
  }

  if (!questionsData || questionsData.length < 1) return null;

  const maxLabelLength = isSmallScreen ? 25 : 50;

  const data = {
    labels: (isSmallScreen ? questionsData.slice(0, 5) : questionsData).map(
      (item) =>
        item.intentName.length > maxLabelLength
          ? `${item.intentName.substring(0, maxLabelLength)}...`
          : item.intentName
    ),
    datasets: [
      {
        data: (isSmallScreen ? questionsData.slice(0, 5) : questionsData).map(
          (item) => item.totalMessages
        ),
        backgroundColor: '#057D99',
        borderRadius: 2
      }
    ]
  };

  const options = generateChartOptions(questionsData, isSmallScreen);

  return (
    <div
      role='img'
      aria-label='Top questions chart'
      style={{ width: '100%', height: '100%', minHeight: 400 }}
    >
      <Bar data={data} options={options} />
    </div>
  );
}

export default TopQuestionsBarChart;
